const deMessages = {
  /* 01.General */
  "chat.end": "Starten Sie Ihr Chat-Gespräch neu",
  "chat.endall": "Ende des Gesprächs",
  "chat.cancel": "Abbrechen",
  "chat.cookie":
    "Dieser digitale Assistent verwendet Cookies, um sicherzustellen, dass Sie die beste Erfahrung machen",
  "chat.learn": "Mehr erfahren",
  "chat.minimize": "Minimieren",
  "chat.hide": "Nah dran",
  "chat.hidebot.text": "Schließen lässt den Avatar für 15 Minuten verschwinden",
  "chat.hidebot": "Bot schließen",
  "chat.restart": "Neu starten",
  "switch.language": "Sprache wechseln",
  "switch.property": "Eigenschaften wechseln",
  "restart.converstation": "Starten Sie die Konvertierung neu",
  "chat.endtext": "Möchten Sie den aktuellen Chat wirklich beenden?",
  "check.availabity": "Verfügbarkeit prüfen",
  "check.availabity.submit": "Einreichen",
  "check.availabity.cancel": "Absagen",
  "check.availabity.adults": "Erwachsene ",
  "check.availabity.children": "Kinder",
  "check.availabity.child.age": "Alter - Kind",
  "feedback.leave": "Hinterlasse Kommentar",
  "feedback.leave.message": "Nachricht hinterlassen",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "Fall einreichen",
  "caseform.system": "System",
  "caseform.loading.systems": "Systeme werden geladen...",
  "caseform.select.system": "System auswählen",
  "caseform.error.systems": "Fehler beim Laden der Systeme",
  "caseform.scenario": "Szenario",
  "caseform.loading.scenarios": "Szenarien werden geladen...",
  "caseform.select.scenario": "Szenario auswählen",
  "caseform.error.scenarios": "Fehler beim Laden der Szenarien",
  "caseform.topic": "Thema",
  "caseform.loading.topics": "Themen werden geladen...",
  "caseform.select.topic": "Thema auswählen",
  "caseform.error.topics": "Fehler beim Laden der Themen",
  "caseform.productArea": "Product Areas",
  "caseform.loading.productAreas": "Loading product areas...",
  "caseform.select.productArea": "Select Product Area",
  "caseform.error.productAreas": "Error loading product areas",
  "caseform.module": "Modules",
  "caseform.loading.modules": "Loading modules...",
  "caseform.select.module": "Select Module",
  "caseform.error.modules": "Error loading modules",
  "caseform.feature": "Features",
  "caseform.loading.features": "Loading features...",
  "caseform.select.feature": "Select Feature",
  "caseform.error.features": "Error loading features",
  "caseform.subject": "Betreff",
  "caseform.description": "Beschreibung",
  "caseform.attachments": "Anhänge",
  "caseform.attachments.remove": "Entfernen",
  "caseform.submit": "Einreichen",
  "caseform.cancel": "Abbrechen",
  "caseform.success.title": "Fall erstellt",
  "caseform.success.message": "Ihr Fall wurde erfolgreich erstellt.",
  "caseform.success.caseNumber": "Fallnummer:",
  "caseform.success.transferToLiveAgent":
    "Sie werden an einen Live-Agenten weitergeleitet.",
  "caseform.success.newChatWindowRightSide":
    "Ein neues Chatfenster wird auf der rechten Seite Ihres Browsers geöffnet.",
  "caseform.success.ok": "OK",
  "simpleaction.title": "Wählen Sie eine Aktion",
  "simpleaction.body":
    "Bitte wählen Sie eine der folgenden Optionen:{br}{b}Erstellen Sie einen Fall{/b}, um eine Supportanfrage zu senden, oder {b}Starten Sie einen Chat{/b}, um jetzt mit einem Agenten zu sprechen.",
  "simpleaction.startchat": "Starten Sie einen Chat",
  "simpleaction.createcase": "Erstellen Sie einen Fall",
  "caseform.error.generic": "Fehler bei der Fall Erstellung.",
  "caseform.error.generic.message":
    "Beim Erstellen Ihres Falls ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
};
export default deMessages;
